export default __webpack_public_path__ + "static/lg-mask-image-0040c794ecf27a0ad091f9d2713f7475.png";